import _ from 'lodash';

import '../styles/cian.offer-type-browser.less';

angular.module('cian.offerTypeBrowser')
  .directive('offerTypeBrowser', function () {
    return {
      scope: {},
      template: require('../../templates/offer-type-browser.html'),
      restrict: 'E',
      controller: [
        '$scope',
        '$element',
        '$timeout',
        'FilterService',
        'FilterObjectTypeService',
        function ($scope, $element, $timeout, FilterService, FilterObjectTypeService) {
          const ctrl = this;

          ctrl.isPopupOpen = false;
          ctrl.openPopup = () => {
            updateTailPos();
            ctrl.isPopupOpen = !ctrl.isPopupOpen;
          };
          ctrl.closePopup = () => ctrl.isPopupOpen = false;

          function updateTailPos () {
            const tailPos = $element[0].offsetLeft + ($element[0].offsetWidth / 2) - 11;
            const tailTransform = `translateX(${tailPos}px) rotateZ(45deg)`;
            ctrl.tailStyle = {
              transform: tailTransform,
              '-webkit-transform': tailTransform,
              '-ms-transform': tailTransform,
              '-o-transform': tailTransform,
            };
          }

          const updateGroups = () => {
            const groups = FilterObjectTypeService.getObjectCategoriesForDeal(
              FilterService.dealType,
              FilterService.isShortTerm(),
            );

            const flatGroup = groups.find(g => g.id === 'flat');
            const suburbanGroup = groups.find(g => g.id === 'suburban');
            const commercialGroup = groups.find(g => g.id === 'commercial');

            // Добавляем опции 'Квартира во вторичке' и 'Квартира в новостройке'
            if (FilterService.dealTypeIs('sale')) {
              flatGroup.items.splice(1, 0, {
                name: 'oldBuildingFlat',
                text: 'Квартира во вторичке',
              }, {
                name: 'newBuildingFlat',
                text: 'Квартира в новостройке',
              });
            }

            // В долгосрочной аренде переносим 'Участок' в коммерческую
            if (FilterService.dealTypeIs('rent') && !FilterService.isShortTerm()) {
              const landObject = _.remove(suburbanGroup.items, o => o.name === 'land')[0];
              commercialGroup.items.push({
                ...landObject,
                text: 'Коммерческая земля',
              });
            }

            ctrl.objectTypesGroups = groups;
          };

          $scope.$watchGroup(
            [() => FilterService.dealType, FilterService.isShortTerm],
            updateGroups
          );

          /**
           * @param {ObjectType} objectType
           * @return {boolean}
           */
          this.isActive = objectType => {
            if (FilterService.isOldBuilding()) {
              return objectType.name === 'oldBuildingFlat';
            }
            if (FilterService.isNewBuilding()) {
              return objectType.name === 'newBuildingFlat';
            }
            return FilterService.objectIsSelected(objectType.name);
          };

          /**
           * @param {ObjectType} objectType
           * @return {boolean}
           */
          this.canBeClicked = objectType => !this.isActive(objectType) ||
            // При мультивыборе можно откликнуть активный объект
            FilterService.objectTypes.length > 1;

          /**
           * @param {ObjectType} objectType
           */
          this.select = objectType => {
            (function () {
              // Мультивыбор в коммерческой
              if (FilterService.categoryIs('commercial') && objectType.category === 'commercial') {
                const newObjects = _.xor(FilterService.objectTypes, [objectType]);
                if (newObjects.length) FilterService.setObjectTypes(newObjects);
                return;
              }

              // Квартира во вторичке
              if (objectType.name === 'oldBuildingFlat') {
                FilterService.setObjectTypes([FilterObjectTypeService.getObjectTypeByName('flat')]);
                FilterService.filter.building_status.value = 1;
                return;
              }

              // Квартира в новостройке
              if (objectType.name === 'newBuildingFlat') {
                FilterService.setObjectTypes([FilterObjectTypeService.getObjectTypeByName('flat')]);
                FilterService.filter.building_status.value = 2;
                return;
              }

              FilterService.setObjectTypes([objectType]);
            })();

            $timeout(updateTailPos);
          };

          ctrl.getSelectedObjectTypeText = function () {
            if (FilterService.isOldBuilding()) return 'Квартиру во вторичке';
            if (FilterService.isNewBuilding()) return 'Квартиру в новостройке';

            // Меняем название участка в коммерческой
            if (FilterService.objectIsSelected('land')) {
              return FilterService.dealTypeIs('rent') ? 'Комм. землю' : 'Участок';
            }

            if (FilterService.objectTypes.length === 1) {
              // Если выбран 1, то показываем его название
              return FilterService.objectTypes[0].title || FilterService.objectTypes[0].text;
            } else {
              // Если выбрано несколько или категория целиком, то показываем название категории
              switch (FilterService.category) {
                case 'flat':
                  return 'Жилую';
                case 'suburban':
                  return 'Загородную';
                case 'commercial':
                  return 'Коммерческую';
              }
            }
          };
        }],
      controllerAs: 'offerTypeBrowser',
    };
  });



// WEBPACK FOOTER //
// ./src/components/offer-type-browser/src/scripts/cian.offer-type-browser.dir.js